// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__Dlux9","sideSprite":"style__sideSprite__9p2Wx","middleSprite":"style__middleSprite__ZlTsq"};